import { Box, Typography } from "@mui/material"

import clock from "static/images/statuses/clocks.png"
import SecondaryButton from "components/shared/buttons/SecondaryButton"
import useAppStore from "../../../store/app"
import useTranslation from "../../../hooks/use_translation"

const NotInfo = () => {
  const { first_name } = useAppStore((state) => state.user)

  const { pages } = useTranslation()

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        color: "white",
        textAlign: "center",
        mb: 4,
      }}
    >
      <Box
        component="img"
        alt="Image"
        src={clock}
        sx={{ maxHeight: 200, maxWidth: 250, mt: 7, alignSelf: "center", mb: -4 }}
      />
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
        {pages?.client_main?.hi}, {first_name}
      </Typography>
      <Typography sx={{ mb: 4 }}>{pages?.client_main?.empty_data_title}</Typography>
      <SecondaryButton text={pages?.client_main?.empty_data_btn} href="/me/anamnesis" />
    </Box>
  )
}

export default NotInfo
